export default __webpack_public_path__ + "static/media/icon_power_outage_false.9e8d5551.svg";